<template>
    <div class="charpert_two">
        <div class="mt-5 p-5">
      <h1 class="font-weight-bolder">Aprende a programar en cinco minutos</h1>
      <p class="mt-5">
        Aprende a programar en cinco minutos o en diez o en veinte minutos,
        estos y otros títulos son muy frecuentes, pero carecen de realidad.<br />
        Entonces, no te hagas falsas ilusiones que la programación es una
        disciplina que requiere mucho tiempo y dedicación. Por eso todos esos
        titulitos llamativos que roban tu atención, no son más que falsa
        publicidad.<br />
        Como te lo he dicho en artículos anteriores, la programación se aprende
        dedicando mucho tiempo. Una de las formas más efectivas de aprender a
        programar es realizando ejercicios que te permitan desarrollar la
        lógica. Si leíste el primer artículo entonces sabes cuáles son las dos
        formas que te recomiendo para empezar a programar. Si te gustó alguno de
        los dos puede realizar ejercicios con estos. Si por el contrario estas
        utilizando un lenguaje en específico, da igual, con cualquiera de las
        dos formas podrás ir desarrollando pequeños programas pequeños para ir
        ejercitando tu lógica y así avanzar en este proceso de aprendizaje.<br />
        Si eres de los que pretende aprender en 5 o en 10 minutos algo que tarda
        meses, entonces cambia de foco, la programación como muchas disciplinas
        demanda de tiempo y de entrega, es un proceso lento y se debe tener
        paciencia, al principio es difícil, pero con dedicación puedes llegar
        muy lejos crear cosas fenomenales.
      </p>
      <br />
      <h2 class="font-weight-bolder">Tips</h2>
      <br />
      <ul>
        <li>Realiza ejercicios usando arrays</li>
        <li>
          Encuentra una letra o una palabra especifica que está almacenada en un
          array
        </li>
        <li>Ejercicios para ordenar arrays</li>
        <li>Recibe datos del usuario y píntalos en la pantalla</li>
        <li>
          Cuando ya conozcas bien tu lenguaje de programación preferido realiza
          proyectos personales
        </li>
      </ul>
      <br />
      <p>
        Si lo tuyo es el desarrollo web y sabes sobre HTML, CSS, JAVASCRIPT
        realiza tu primera página o aplicación web. No importa que tan sencilla
        sea, esto será parte fundamental en tu proceso porque te ayudará a
        mejorar.
      </p>
      <p>
        No tengas miedo a equivocarte, si te equivocas, vuelve a empezar.
      </p>
      <p>Imagina, resuelve, y programa.</p>
      <h3 class="font-weight-bolder">link de utilidad</h3>
      <p>
        Uno de los mejores sitios gratuitos para aprender sobre desarrollo web
      </p>
      <a href="https://www.w3schools.com/">Ir al sitio </a>
        </div>
    </div>
</template>
<script>
export default {
    name:"charpert_two"
}
</script>
<style lang="scss" scoped>
p,li{
  
  font-size: 20px;;

}
</style>